/* eslint-disable no-plusplus */
const tableMembers = document.querySelector('.table-members');
const tableClasses = document.querySelector('.table-classes');
function ResponsiveCellHeaders(elmClass) {
    try {
        const THarray = [];
        const table = document.querySelector(elmClass);
        const ths = table.getElementsByTagName('th');
        for (let i = 0; i < ths.length; i++) {
            let headingText = ths[i].innerHTML;
            headingText = headingText.replace(/<span[\s\S]*?<\/span>/g, '');
            THarray.push(headingText);
        }
        const styleElm = document.createElement('style');
        document.head.appendChild(styleElm);
        const styleSheet = styleElm.sheet;
        for (let i = 0; i < THarray.length; i++) {
            if (THarray[i] !== '') {
                styleSheet.insertRule(
                    `${elmClass} td:nth-child(${i + 1})::before {content:"${THarray[i]}: ";}`,
                    styleSheet.cssRules.length,
                );
            }
        }
    } catch (e) {
        window.console.log(`ResponsiveCellHeaders(): ${e}`);
    }
}
if (tableMembers !== null) {
    ResponsiveCellHeaders('.table-members');
}
if (tableClasses !== null) {
    ResponsiveCellHeaders('.table-classes');
}
